(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks-wager/assets/javascripts/use-draw-result-for-wager.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks-wager/assets/javascripts/use-draw-result-for-wager.js');
"use strict";

const {
  useDrawResultFromCurrentWagerDraw
} = svs.components.tipsen.hooksWager;
const useDrawResultForWager = _ref => {
  let {
    wagerId
  } = _ref;
  const [result] = useDrawResultFromCurrentWagerDraw({
    wagerId
  });
  const [drawResults, drawWinDivs, multiForecast] = result.data;
  const drawResultError = result.error;
  const refetchDrawResult = result.refetch;
  return {
    drawResults,
    drawWinDivs,
    multiForecast,
    drawResultError,
    refetchDrawResult
  };
};
setGlobal('svs.components.tipsen.hooksWager.useDrawResultForWager', useDrawResultForWager);

 })(window);